export const isUndefined = (val: unknown): val is undefined =>
  val === undefined;

export const isString = (value: unknown): value is string =>
  typeof value === "string";
